export default {"src":"/_next/static/media/quote.17277439.svg","height":80,"width":100,"blurWidth":0,"blurHeight":0};